import { EAiAssistantChannel } from "modules/aiAgents/aiAgents.types";
import { useGetAssistants } from "modules/aiAgents/apis";

import { ESupportTicketSource } from "../../aiTickets.types";
import { AssignedAgent } from "../AssignedAgent";

// "Assigned agent" is the AI agent handling the ticket. There's exactly one
// assistant per channel (the ai_assistant.channel unique index), so it's
// derived from the ticket source — read-only, there's nothing to pick.
const CHANNEL_BY_SOURCE: Record<ESupportTicketSource, EAiAssistantChannel> = {
  [ESupportTicketSource.WhatsApp]: EAiAssistantChannel.WhatsApp,
  [ESupportTicketSource.InAppSupport]: EAiAssistantChannel.InAppSupport,
};

interface Props {
  source: ESupportTicketSource;
}

const AssignedAgentCell = ({ source }: Props) => {
  const { assistants } = useGetAssistants();

  const agent =
    assistants.find((a) => a.channel === CHANNEL_BY_SOURCE[source]) ?? null;

  return <AssignedAgent agent={agent ? { name: agent.name } : null} />;
};

export default AssignedAgentCell;
